"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.json = json;
exports.body = body;
function json(request) {
  return new Promise(function (resolve, reject) {
    request.then(function (response) {
      return response.json();
    }).then(function (json) {
      resolve(json);
    }).catch(function (e) {
      reject(e);
    });
  });
}

function body(request) {
  return new Promise(function (resolve, reject) {
    request.then(function (response) {
      return response.body();
    }).then(function (body) {
      resolve(body);
    }).catch(function (e) {
      reject(e);
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/http-otro/lib/response.js
// module id = yHio
// module chunks = 0